/** @format */

import React from "react";

import styles from "./ItemPlan.module.scss";
import { Button } from "primereact/button";
import CustonItem from "./CustonItem/CustonItem";
// import useItemPlan from "./useItemPlan";

export default function ItemPlan({
	type = "Essentials",
	code = "",
	price = "",
}: {
	type?: string;
	code?: string;
	price?: string;
}) {
	if (type === "Premium") {
		return (
			<article className={styles.containerPremium}>
				<div className={styles.premiumContainerInfo}>
					<h2 className={styles.premiumTitle}>{type}</h2>
					<span className={styles.premiumSubtitle}>{code}</span>
					<h2 className={styles.premiumPrice}>${price}</h2>
					<span className={styles.premiumSubtitle}>/Month</span>
				</div>
				<a href="https://inspectionmanager.secure.force.com/" target="_top">
					<Button className="btn btn-white" label="Start free trial" aria-label="Submit"></Button>
				</a>
				<div className={styles.premiumContainerList}>
					<CustonItem text="All Essentials Features" type="Premium" />
					<span style={{ color: "white" }}>PLUS</span>
					<CustonItem text="Tenancy Agreements" type="Premium" />
					<CustonItem text="Leases Renewals" type="Premium" />
					<CustonItem text="Rent Increase Notices" type="Premium" />
					<CustonItem text="Utility Connections" type="Premium" />
				</div>
				<div className={styles.premiumFooter}>NSW, QLD & VIC Only</div>
			</article>
		);
	}
	return (
		<article className={styles.containerEssentials}>
			<div className={styles.essentialsContainerInfo}>
				<h2 className={styles.essentialsTitle}>{type}</h2>
				<span className={styles.essentialsSubtitle}>{code}</span>
				<h2 className={styles.essentialsPrice}>${price}</h2>
				<span className={styles.essentialsSubtitle}>/Month</span>
			</div>
			<a href="https://inspectionmanager.secure.force.com/" target="_top">
				<Button className="btn btn-blue" label="Start free trial" aria-label="Submit"></Button>
			</a>
			<div className={styles.essentialsContainerList}>
				<CustonItem text="Routine Inspections & Property Condition Reports" type="Essentials" />
				<CustonItem text="Paperless Condition Reports" type="Essentials" />
				<CustonItem text="Tenant Assisted Inspection" type="Essentials" />
				<CustonItem text="Video for Routine Inspections" type="Essentials" />
				<CustonItem text="Trust Account Integration" type="Essentials" />
			</div>
			<div className={styles.essentialsFooter}></div>
		</article>
	);
}

//
